<template>
  <div class="gs-app gm-suppressors">
    <div class="gm-suppressors__tabs flex flex-col w-full relative">
      <div class="gm-suppressors__tab-list w-full absolute left-0 absolute groovemail-suppresors-tabs">
        <div class="flex bg-white border-b-2 border-grey-200">
          <gd-tabs
            :tabs="suppressorsTabs"
            :current-tab="suppressorTab"
            :tab-active-class="'p-2 border-primary border-b-2 text-primary gs-default-tabs-item-active'"
            :line-class="'gs-default-tabs-active-line'"
            class="mail_suppressions_tab_head"
            @onClick="handlesuppressorTabChange"
          />
        </div>
      </div>
    </div>
    <div class="gm-suppressors__content mt-2">
      <div
        v-if="suppressorTab === 'emails'"
        class="w-full flex flex-col relative"
      >
        <SuppressorsData
          :ref="suppressorTab"
          :key="'email'"
          :from="'email'"
          :tableTitle="'frontend_groovemail_components_suppressions_suppressors_emails'"
          :addSuppressorBtnText="'frontend_groovemail_components_suppressions_suppressors_add_emails_suppressors'"
          :suppressorsTableColumns="emailSuppressorsTableColumns"
          :suppressorsTableOptions="emailSuppressorsTableOptions"
          :suppressorDataUrl="suppressionEmailsUrl"
          :suppressorDataUploadUrl="uploadEmailsCsvUrl"
          :suppressorSampleDownloadUrl="sampleEmailsCsvDownloadUrl"
          :addSuppresorModalTitle="'frontend_groovemail_components_suppressions_suppressors_add_emails_suppressors'"
          :suppressorModalPlaceholder="'frontend_groovemail_suppressions_enter_emails_suppressors'"
          :suppressorModalNote="'frontend_groovemail_suppressions_emails_suppressors_note'"
          @showLoader="showLoader()"
          @hideLoader="hideLoader()"
        ></SuppressorsData>
      </div>
      <div
        v-if="suppressorTab === 'domains'"
        class="w-full flex flex-col relative"
      >
        <SuppressorsData
          :ref="suppressorTab"
          :key="'domain'"
          :from="'domain'"
          :tableTitle="'frontend_groovemail_components_suppressions_suppressors_domains'"
          :addSuppressorBtnText="'frontend_groovemail_components_suppressions_suppressors_add_domains_suppressors'"
          :suppressorsTableColumns="domainSuppressorsTableColumns"
          :suppressorsTableOptions="domainSuppressorsTableOptions"
          :suppressorDataUrl="suppressionDomainsUrl"
          :suppressorDataUploadUrl="uploadDomainsCsvUrl"
          :suppressorSampleDownloadUrl="sampleDomainsCsvDownloadUrl"
          :addSuppresorModalTitle="'frontend_groovemail_components_suppressions_suppressors_add_domains_suppressors'"
          :suppressorModalPlaceholder="'frontend_groovemail_suppressions_enter_domains_suppressors'"
          :suppressorModalNote="'frontend_groovemail_suppressions_domains_suppressors_note'"
          @showLoader="showLoader()"
          @hideLoader="hideLoader()"
        ></SuppressorsData>
      </div>
      <div
        v-if="suppressorTab === 'tlds'"
        class="w-full flex flex-col relative"
      >
        <SuppressorsData
          :ref="suppressorTab"
          :key="'tld'"
          :from="'tld'"
          :tableTitle="'frontend_groovemail_components_suppressions_suppressors_tlds'"
          :addSuppressorBtnText="'frontend_groovemail_components_suppressions_suppressors_add_tlds_suppressors'"
          :suppressorsTableColumns="tldSuppressorsTableColumns"
          :suppressorsTableOptions="tldSuppressorsTableOptions"
          :suppressorDataUrl="suppressionTldsUrl"
          :suppressorDataUploadUrl="uploadTldsCsvUrl"
          :suppressorSampleDownloadUrl="sampleTldsCsvDownloadUrl"
          :addSuppresorModalTitle="'frontend_groovemail_components_suppressions_suppressors_add_tlds_suppressors'"
          :suppressorModalPlaceholder="'frontend_groovemail_suppressions_enter_tlds_suppressors'"
          :suppressorModalNote="'frontend_groovemail_suppressions_tlds_suppressors_note'"
          @showLoader="showLoader()"
          @hideLoader="hideLoader()"
        ></SuppressorsData>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SuppressorsData from './suppressors-data.vue';
import { suppressorsUrl } from '@/utils/urls.js';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';

let self;

export default {
  mixins: [demoModeValuesMixin],
  data() {
    return {
      suppressorTab: 'emails',
      suppressionEmailsUrl: suppressorsUrl.suppressionEmails,
      uploadEmailsCsvUrl: suppressorsUrl.uploadEmailsCsv,
      sampleEmailsCsvDownloadUrl: suppressorsUrl.sampleEmailsCsvDownload,
      suppressionDomainsUrl: suppressorsUrl.suppressionDomains,
      uploadDomainsCsvUrl: suppressorsUrl.uploadDomainsCsv,
      sampleDomainsCsvDownloadUrl: suppressorsUrl.sampleDomainsCsvDownload,
      suppressionTldsUrl: suppressorsUrl.suppressionTlds,
      uploadTldsCsvUrl: suppressorsUrl.uploadTldsCsv,
      sampleTldsCsvDownloadUrl: suppressorsUrl.sampleTldsCsvDownload,
      emailSuppressorsTableColumns: ['email', 'created_at', 'actions'],
      
      domainSuppressorsTableColumns: ['domain', 'created_at', 'actions'],
      
      tldSuppressorsTableColumns: ['tld', 'created_at', 'actions'],
      
    };
  },

  methods: {
    // show loader
    showLoader() {
      this.$emit('showLoader');
    },

    // hide loader
    hideLoader (){
      this.$emit('hideLoader');
    },

    /**
     * Used to handle tab change based on suppression type.
     * @param {string} newTab changed tab.
     */
    handlesuppressorTabChange(newTab) {
      this.suppressorTab = newTab;
    },
  },
  components: {
    SuppressorsData,
  },

  created(){
    self = this;
  },

  watch: {
    // Used to refresh black list table when demo mode changes
    demoMode() {
      this.$refs[this.suppressorTab].$refs.serverTable.$refs.suppressorsTable.refresh();
    },
  },

  computed: {
    /**
     * Returns tabs data.
     * @return {array} - suppression tabs
     */
    suppressorsTabs() {
      return [
        {
          title: `<span class="text-sm font-semibold">&nbsp;${this.$t(
            'frontend_groovemail_components_suppressions_suppressors_emails'
          )} <span>`,
          value: 'emails',
        },
        {
          title: `<span class="text-sm font-semibold">&nbsp;${this.$t(
            'frontend_groovemail_components_suppressions_suppressors_domains'
          )} <span>`,
          value: 'domains',
        },
        {
          title: `<span class="text-sm font-semibold">&nbsp;${this.$t(
            'frontend_groovemail_components_suppressions_suppressors_tlds'
          )} <span>`,
          value: 'tlds',
        },
      ];
    },

    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },

    // Define a computed property called commonOptions that contains the common options for all three table options objects
    commonOptions() {
      return {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        // Define an async requestFunction that makes an HTTP GET request to the specified URL with the given data
        async requestFunction(data) {
          return axios
            .get(this.url, {
              params: data,
            })
            .catch((e) => {
              this.dispatch('error', e);
              this.$parent.$parent.hideLoader();
            });
        },
        // Define a responseAdapter function that adapts the response data to the format expected by the table component
        responseAdapter({ data }) {
          if (this.demoMode) {
            const newData = data[0]?.data.map((obj) => ({
              ...obj,
              email: this.basicEmailText,
            }));

            return {
              data: newData,
              count: newData.length,
            };
          }
          return {
            data: data[0].data,
            count: data[0].total,
          };
        },
      };
    },

    // Define a computed property called emailSuppressorsTableOptions that contains the options for the email suppressors table
    emailSuppressorsTableOptions() {
      return {
        ...this.commonOptions, // Merge the common options with the specific options for the email suppressors table
        headings: {
          email: () =>
            this.$t(
              'frontend_groovemail_components_suppressions_suppressors_emails'
            ),
          created_at: () => this.$t('frontend_groovemail_created_at'),
          actions: () => this.$t('frontend_groovemail_mail_lead_actions'),
        },
        filterable: ['email'],
        sortable: ['email', 'created_at'],
      };
    },

    // Define a computed property called domainSuppressorsTableOptions that contains the options for the domain suppressors table
    domainSuppressorsTableOptions() {
      return {
        ...this.commonOptions, // Merge the common options with the specific options for the domain suppressors table
        headings: {
          domain: () =>
            this.$t(
              'frontend_groovemail_components_suppressions_suppressors_domains'
            ),
          created_at: () => this.$t('frontend_groovemail_created_at'),
          actions: () => this.$t('frontend_groovemail_mail_lead_actions'),
        },
        filterable: ['domain'],
        sortable: ['domain', 'created_at'],
      };
    },

    // Define a computed property called tldSuppressorsTableOptions that contains the options for the TLD suppressors table
    tldSuppressorsTableOptions() {
      return {
        ...this.commonOptions, // Merge the common options with the specific options for the TLD suppressors table
        headings: {
          tld: () =>
            this.$t(
              'frontend_groovemail_components_suppressions_suppressors_tlds'
            ),
          created_at: () => this.$t('frontend_groovemail_created_at'),
          actions: () => this.$t('frontend_groovemail_mail_lead_actions'),
        },
        filterable: ['tld'],
        sortable: ['tld', 'created_at'],
      };
    },
  },
};
</script>

<style scoped>
.gm-suppressors {
  min-width: 0;
  color: var(--gs-foreground);
}

.gm-suppressors__tab-list {
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gm-suppressors__content {
  min-width: 0;
}

@media (max-width: 640px) {
  .gm-suppressors__tab-list {
    border-radius: var(--gs-radius-md);
  }
}
</style>
